import { BaseRouteService } from "core/services";

class FacilityOrderRouteService extends BaseRouteService {
	constructor() {
		super("facility-orders");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,accountManagerId,importHeaderStatusId,facilityId,nextOrderingDate,dateOfService,nextDeliveryDate,createdAt,isNewFlow2,intakeRepId,userRepId,facilityInventoryCountHeaderId,isNiko,isSendOrder}`, filter);
	}	
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}	
	
	getStatistic(id) {		
		return super.get(`${this.base}/statistic/{id}`, id);	
	}	
	
	create(resource) {		
		return super.create(this.base, resource);	
	}

	createCsv(formData) {
		return super.update(`${this.base}/csv`, { formData});
	}

	update(resource) {
		return super.update(`${this.base}/{id}`, resource);	
	}	

	importFacilityOrder(resource) {
		return super.update(`${this.base}/{facilityOrderId}/import{?patientId}`, resource);	
	}	

	isReadyForImportFacilityOrder(resource) {
		return super.find(`${this.base}/{facilityOrderId}/is-ready-for-import{?patientId}`, resource);	
	}	

	setDateInitialReviewCompleted(resource) {
		return super.update(`${this.base}/{id}/update-date-initial-review-completed`, resource);	
	}	

	delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

	setInsuranceReviewCompletedDate(resource) {
		return super.update(`${this.base}/{id}/update-insurance-review-completed-date`, resource);	
	}

	setMissingInventoryCount(resource) {
		return super.update(`${this.base}/{facilityOrderId}/update-missing-inventory-count`, resource);	
	}

	setNikoMissingInventoryCount(resource) {
		return super.update(`${this.base}/{facilityOrderId}/update-niko-missing-inventory-count`, resource);	
	}

	importFacilityOrderNewFlow(resource) {
		return super.update(`${this.base}/{facilityOrderId}/import-new-flow{?patientId,facilityOrderTemplateId}`, resource);	
	}

	getTargetPage(id) {
		return super.get(`${this.base}/{id}/target-page`, id);	
    }

	getNikoTargetPage(id) {
		return super.get(`${this.base}/{id}/niko-target-page`, id);	
    }
	
	isInventoryStepAllowed(id) {		
		return super.get(`${this.base}/{id}/is-inventory-step-allowed`, id);	
	}	

	isNikoInventoryStepAllowed(id) {		
		return super.get(`${this.base}/{id}/is-niko-inventory-step-allowed`, id);	
	}	
	
	markInventoryReportAsSent(id, requestType) {
		return super.update(`${this.base}/${id}/mark-inventory-report-as-sent?requestType=${requestType}`);	
	}

	checkPreviousFacilityOrders(id) {
		return super.get(`${this.base}/check-previous-facility-orders/{id}`, id);
	}

	getSentEmailInfo(facilityOrderId, emailType) {
		return super.get(`${this.base}/get-sent-email-info?facilityOrderId=${facilityOrderId}&emailType=${emailType}`)
	}

	hasSentEmail(facilityOrderId, emailType) {
		return super.get(`${this.base}/has-sent-email?facilityOrderId=${facilityOrderId}&emailType=${emailType}`)
	}

	hasPrimaryRecipient(facilityOrderId) {
		return super.get(`${this.base}/${facilityOrderId}/has-primary-recipient`)
	}

	hasPrimaryRecipientNiko(facilityOrderId) {
		return super.get(`${this.base}/${facilityOrderId}/has-primary-recipient-niko`)
	}

	importCheckNiko(id) {
		return super.get(`${this.base}/import-check-niko/{id}`, id, null);
	}

	sendPackingListEmail(){
		return super.update(`${this.base}/process/packing-list`);
	}

	sendNikoPackingListEmail(){
		return super.update(`${this.base}/process/niko-packing-list`);
	}

	sendNikoPackingListEmailSingle(facilityOrderId){
		return super.update(`${this.base}/process/niko-packing-list/{facilityOrderId}`, { facilityOrderId });
	}

	createNikoFacilityOrder(facilityScheduleDateId){
		return super.create(`${this.base}/create-niko-facility-order/{facilityScheduleDateId}`, { facilityScheduleDateId });	
	}
	
	deleteNikoFacilityOrder(resource) {
        return super.delete(this.base + '/delete-niko-facility-order/{id}', resource);
    }

	sendOrder(resource) {
		return super.update(`${this.base}/send-order/{id}`, resource);
	}

	addIvPoles(resource) {
		return super.update(`${this.base}/add-iv-poles/{id}`, resource);
	}

	hasBackorderedItemNiko(id) {
		return super.get(`${this.base}/has-backordered-item-niko/{id}`, id);
	}

	createNikoSOs(facilityOrderId) {
		return super.create(`${this.base}/{facilityOrderId}/niko/process`, { facilityOrderId });
	}

	createNikoSOsAllFacilityOrders() {
		return super.create(`${this.base}/niko/process-scheduled`);
	}

	createNikoInvoicesAllFacilityOrders() {
		return super.create(`${this.base}/niko/invoice/process-scheduled`);
	}

	createNikoInvoices(facilityOrderId) {
		return super.create(`${this.base}/{facilityOrderId}/niko/invoice`, { facilityOrderId });
	}
}

export default FacilityOrderRouteService;